import { useEffect, useState } from "react";
import { MASCOT_ZONES, type MascotZone } from "./zones";

/**
 * Returns the highest-priority mascot zone currently intersecting the middle
 * of the viewport. One IntersectionObserver, cheap.
 */
export const useActiveZone = (): MascotZone | null => {
  const [zoneIndex, setZoneIndex] = useState<number | null>(null);

  useEffect(() => {
    const pairs: { el: Element; index: number }[] = [];
    MASCOT_ZONES.forEach((zone, index) => {
      document
        .querySelectorAll(zone.selector)
        .forEach((el) => pairs.push({ el, index }));
    });
    if (!pairs.length) return;

    const visible = new Set<number>();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const match = pairs.find((p) => p.el === entry.target);
          if (!match) return;
          if (entry.isIntersecting) visible.add(match.index);
          else visible.delete(match.index);
        });
        const top = [...visible].sort((a, b) => a - b)[0];
        setZoneIndex(top ?? null);
      },
      { rootMargin: "-40% 0px -40% 0px" }
    );

    pairs.forEach((p) => observer.observe(p.el));
    return () => observer.disconnect();
  }, []);

  return zoneIndex === null ? null : MASCOT_ZONES[zoneIndex];
};
